import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext.js'; // Adjust path if your context is elsewhere

/**
 * This component acts as a "guard" for protected routes.
 * It checks if the user is logged in via the AuthContext.
 * If the user exists, it renders the child route (using <Outlet />).
 * If the user does NOT exist, it redirects them to the /auth page.
 */
const UserPrivateRoute = () => {
  const { user } = useContext(AuthContext);

  // Check if the user object is present in the context
  // The 'replace' prop ensures the user can't use the "back" button
  // to return to the protected route after being redirected.
  return user ? <Outlet /> : <Navigate to="/auth" replace />;
};

export default UserPrivateRoute;

